import { ICustomConfigurationService } from '@intigral/domain/lib/application/services/CustomConfigurationService';
import { container } from '@intigral/domain/lib/DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { useQuery } from '@tanstack/react-query';
import useLanguage from './useLanguage';

/** CMS footer content, shared with the mobile menu */
export const useFooterMenuQuery = () => {
    const language = useLanguage();
    const customService = container.resolve<ICustomConfigurationService>(DI.SERVICES.ICustomConfigurationService);

    return useQuery({
        queryKey: ['footerMenu', language],
        queryFn: async () => {
            const result = await customService.getFooterMenuContent();
            return result || { footerMenu: [], socialMediaLinks: [], appLinks: [] };
        },
    });
};
